import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { appSetup } from "../../../features/master/masterSlice";
import "./Chatbot.css";

const WhatsappChatbot = ({ message = "" }) => {
  const dispatch = useDispatch();

  const { app_setup } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const phoneNumber = app_setup?.contact_no;

  // Don't render until number is available
  if (!phoneNumber) return null;

  const waLink = `https://wa.me/91${phoneNumber}${
    message ? `?text=${encodeURIComponent(message)}` : ""
  }`;

  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp_chatbot"
      aria-label="Chat with us on WhatsApp"
    >
      <FontAwesomeIcon
        icon={faWhatsapp}
        className="whatsapp_icon"
      />
    </a>
  );
};

export default WhatsappChatbot;